import { render } from "./Routes.vue?vue&type=template&id=1db5c40e&scoped=true&lang=pug"
import script from "./Routes.vue?vue&type=script&lang=ts"
export * from "./Routes.vue?vue&type=script&lang=ts"

import "./Routes.vue?vue&type=style&index=0&id=1db5c40e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1db5c40e"

export default script